import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetInformationAboutApplication = createAsyncThunk(
  "dropdowns/GetInformationAboutApplication",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ApplicationInf/GetApplcationInfo",parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const InformationAboutApplication = createSlice({
  name: "InformationAboutApplication",
  initialState: {
    InformationAboutApplicationInfo: [],
    loadingInformationAboutApplication: false,
    errorInformationAboutApplication: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetInformationAboutApplication.pending, (state, action) => {
        state.loadingInformationAboutApplication = true;
        state.InformationAboutApplicationInfo = action.payload;
        state.errorInformationAboutApplication = null;
      })
      .addCase(GetInformationAboutApplication.fulfilled, (state, action) => {
        state.loadingInformationAboutApplication = false;
        state.InformationAboutApplicationInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetInformationAboutApplication.rejected, (state, action) => {
        state.loadingInformationAboutApplication = false;
        state.InformationAboutApplicationInfo = action.payload;
      });
  },
});

export default InformationAboutApplication.reducer;
